function getScoreColor(score) {
  if (score >= 80) return 'text-green-600 dark:text-green-400'
  if (score >= 60) return 'text-blue-600 dark:text-blue-400'
  if (score >= 40) return 'text-amber-600 dark:text-amber-400'
  return 'text-red-600 dark:text-red-400'
}

function FrameworkCoverageTable({ frameworks, disclaimer }) {
  const entries = frameworks ? Object.entries(frameworks) : []

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              <th className="pb-2 pr-4">Framework</th>
              <th className="pb-2 pr-4">Questions Mapped</th>
              <th className="pb-2 pr-4">Avg Score</th>
              <th className="pb-2 pr-4">Strong Domains</th>
              <th className="pb-2">Weak Domains</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-700/30">
            {entries.map(([name, fw]) => (
              <tr key={name}>
                <td className="py-2.5 pr-4 font-medium text-gray-900 dark:text-white">{name}</td>
                <td className="py-2.5 pr-4 text-gray-600 dark:text-gray-300">
                  {fw.questionsMapped ?? '-'}
                </td>
                <td className={`py-2.5 pr-4 font-semibold ${getScoreColor(fw.averageScore)}`}>
                  {fw.averageScore != null ? `${Math.round(fw.averageScore)}%` : '-'}
                </td>
                <td className="py-2.5 pr-4 text-gray-600 dark:text-gray-300">
                  {fw.strongDomains?.length > 0
                    ? fw.strongDomains.join(', ')
                    : '-'}
                </td>
                <td className="py-2.5 text-gray-600 dark:text-gray-300">
                  {fw.weakDomains?.length > 0
                    ? fw.weakDomains.join(', ')
                    : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {disclaimer && (
        <div className="mt-4 border-l-2 border-blue-400 dark:border-blue-500 bg-blue-50/50 dark:bg-blue-900/10 rounded-r-lg px-4 py-3">
          <p className="text-xs text-gray-600 dark:text-gray-400 leading-relaxed">{disclaimer}</p>
        </div>
      )}
    </div>
  )
}

export default FrameworkCoverageTable
